/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestResponse } from 'src/app/model';
import { SearchableProvider } from 'src/app/model/interface';
import { environment } from 'src/environments/environment';
import { SystemType } from '../model/enums/system.type';
import { Sic } from '../model/sic';
import { ApiHeaders } from './headers';

@Injectable()
export class ReportQuoteProvider implements SearchableProvider {

  constructor(
    private http: HttpClient
  ) { }

  getSearchType(): string {
    return 'REPORT';
  }

  getReports(page: number, query?: string, sort?: boolean, order?: string, filter?: string, filterBy?: string, size?: number, qType?: string, type?: string): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/pma/report/list?page=${page}&size=${size}&sort=${sort}&order=${order}`,
        {
          TYPE: type,
          QUERY_TYPE: qType,
          QUERY: query,
        },
        ApiHeaders.getOptions());
  }

  save(id: string, field: string, value: any): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/pma/report/${id}/field`, {
        FIELD: field,
        VALUE: value
      }, ApiHeaders.getOptions());
  }

  search(query?: string, id?: string, nonBank?: boolean, lsp?: boolean, page?: number, position?: string, type?: SystemType): Observable<RestResponse> {
    return this.getReports(page ? page : 1, query, true, 'CREATED_DATE', null, null, 25, 'COMPANY_NAME', type);
  }
}
